import { useState, useEffect } from 'react';
import { GetConfiguration, UpdateConfiguration } from '../../api/Api';
import { useForm, FormProvider } from "react-hook-form";
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { addOrModifyConfiguration } from '../../Models/AddOrModifyConfigurationRequest'
import { authCredentials } from '../../Models/AuthCredentials';
import CredentialComponent from './CredentialComponent';
import Card from '../Card/Card';

import '../../App.css'


function EditConfigurationForm(props){

    const [configurationData, setConfigurationData] = useState({});
    const [showAlert, setShowAlert] = useState(false);
    const [alertData, setAlertData] = useState({});

    const methods = useForm();
    const { handleSubmit, register, reset, formState } = methods;
    const { dirtyFields } = formState;

    useEffect(() => {
        GetConfiguration(props.productName, props.configurationName).then(
            (res) =>  
            {
                setConfigurationData(res.data);
            });
    }, [props.productName, props.configurationName]);
    
    async function onSubmit(data){
        let configUpdateRequest = new addOrModifyConfiguration(
            configurationData.productName, 
            configurationData.configurationName, 
            dirtyFields.description === true? data.description : configurationData.description, 
            dirtyFields.value === true? data.value : configurationData.value);

        let credentials = new authCredentials(data.username, data.password);
        let updatedConfigurationData = {...configurationData};
        updatedConfigurationData.description = configUpdateRequest.description;
        updatedConfigurationData.value = configUpdateRequest.value;
        
        try {
            let response = await UpdateConfiguration(configUpdateRequest, credentials);
            handleResponse(response);
            setConfigurationData(updatedConfigurationData);
            reset();
        } catch (err) {
            handleResponse(err.response);
        }
    }

    function handleResponse(response){
        if (response.status === 200){
            setShowAlert(true);
            let data = {
                variant:'primary', 
                heading:`Request status: ${response.status}`, 
                message:response="The Configuration has been modified successfully"
            }
            setAlertData(data);
        } else if (response.status === 400){
            setShowAlert(true);
            let data = {
                variant:"danger", 
                heading:`Request status: ${response.status}`, 
                message:"Invalid Login"
            }
            setAlertData(data);
        }
        else if (response.status === 401){
            setShowAlert(true);
            let data = {
                variant:"danger", 
                heading:`Request status: ${response.status}`, 
                message:"User is not authorized"
            }
            setAlertData(data);
        } else {
            setShowAlert(true);
            let data = {
                variant:"danger", 
                heading:`Request status: ${response.status}`, 
                message:response=response.data.Message
            }
            setAlertData(data);
        }
    }

    return (
        <section >
            <FormProvider {...methods} >
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <Form.Group>
                        <Form.Label>Configuration Name</Form.Label>
                        <Form.Control type='text' name="configurationName" readOnly {...register('configurationName')} defaultValue={configurationData.configurationName} />
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>Product Name</Form.Label>
                        <Form.Control type='text' name="productName" readOnly {...register('productName')} defaultValue={configurationData.productName} />
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>Description</Form.Label>
                        <Form.Control type='text' name="description" required {...register('description')} defaultValue={configurationData.description} />
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>Value</Form.Label>
                        <Form.Control type='text' name="value" required {...register('value')} defaultValue={configurationData.value} />
                    </Form.Group>
                    <CredentialComponent />
                    <Button variant='secondary' type='submit'>Submit</Button>
                </Form>
            </FormProvider>
            <br />
            <Card show={showAlert} variant={alertData.variant} heading={alertData.heading} message={alertData.message}></Card>
        </section>
    );
}

export default EditConfigurationForm;